module.exports = __webpack_public_path__ + "media/id.17b99676.svg";